var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
var Heading = function (_a) {
    var title = _a.title, styles = _a.styles;
    var t = useTranslation('settings').t;
    return (_jsx(Typography, { variant: "h6", component: "h3", sx: __assign({ mb: 2, textAlign: 'center' }, styles), children: t(title) }));
};
export default Heading;
